import { ACTION_NAME, LOAD_STATUS } from "../js/constant";
import MessageBox from "../../../../components/message-box";

export default function Reducers(state, action) {
  switch (action.type) {
    // 设置页面基础配置信息
    case ACTION_NAME.SET_PAGE_CONFIG_DATA:
      return Object.assign({}, state, {
        baseConfig: action.payload,
      });
    case ACTION_NAME.CREATE_RESCUE_ORDER:
      if (action.loadStatus === LOAD_STATUS.SUCCESS) {
        const { code } = action.payload;
        // if (code === ERROR_CODE_MAP.ORDER_REPEAT) {
        //   MessageBox.toast('车辆已经在救援中。如需查询进度，请回到救援首页。', { timeout: 3000 });
        //   return state;
        // }
        if (code === 200) {
          return Object.assign({}, state, {
            createOrderState: 1,
          });
        }
        return Object.assign({}, state, {
          createOrderState:
            state.createOrderState >= 0 ? -1 : state.createOrderState - 1,
        });
      } else if (action.loadStatus === LOAD_STATUS.FAIL) {
        const errMsg =
          action?.payload?.msg ||
          action?.payload?.response?.data?.msg ||
          action?.payload?.message ||
          "网络异常，请稍后重试";
        MessageBox.toast(`提交失败: ${errMsg}`, {
          timeout: 3000,
        });
        return Object.assign({}, state, {
          createOrderState:
            state.createOrderState >= 0 ? -1 : state.createOrderState - 1,
        });
      }
      return {
        ...state,
        loadStatus: action.loadStatus,
      };
    case ACTION_NAME.SET_UPLOAD_IMGS_DATA:
      return Object.assign({}, state, {
        uploadedImageList: action.payload,
      });
    // 重置表单数据
    case ACTION_NAME.RESET_FORM_DATA:
      return Object.assign({}, state, {
        ...action.payload,
      });
    default:
      return state;
  }
}
